<template>
  <div class="slide-tip">
    <div class="twinkle-wrapper">
      <div
        class="slide-tip_text"
        v-html="text"
      />
      <img
        class="slide-tip_image"
        src="@/assets/image/下拉.png"
        alt=""
        draggable="false"
      >
    </div>
    <img
      src="@/assets/image/slide-tip-hand.png"
      class="slide-tip_hand"
      alt=""
      draggable="false"
    >
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.slide-tip {
  position: absolute;
  bottom: 6.17rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.13rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #18489D;
  > .twinkle-wrapper {
    animation: twinkle 2s infinite;
    > .slide-tip_text {
    }
    > .slide-tip_image {
      width: 0.94rem;
      height: 2.47rem;
      margin-top: 0.94rem;
    }
  }
  .slide-tip_hand {
    position: absolute;
    left: 50%;
    width: 2.26rem;
    animation: move-up-down 2.8s infinite;
  }
}
@keyframes twinkle {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes move-up-down {
  0% {
    top: 0;
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    top: 100%;
    opacity: 0;
  }
}
</style>
